var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"d-block",attrs:{"to":_vm.link}},[_c('div',{staticClass:"my-btn"},[_c('span',[_vm._v(_vm._s(_vm.text))]),_c('i',{staticClass:"fab fa-long-arrow-right"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }